import { Accordion } from '@base-ui/react/accordion';
import styled from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
const ICON_WRAPPER_SIZE = pxToRem(24);
export const AccordionStateIconWrapper = styled.div `
  width: ${ICON_WRAPPER_SIZE};
  height: ${ICON_WRAPPER_SIZE};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
export const AccordionHeader = styled(Accordion.Header) `
  cursor: pointer;
  padding: ${themeGet('spacing.md')};
  border-radius: ${themeGet('borderRadius.md')};
  transition: background-color 175ms ease-in-out;

  &:hover {
    background-color: ${themeGet('colors.gray.50')};
  }

  &[data-open] {
    ${AccordionStateIconWrapper} {
      transform: rotate(90deg);
    }
  }
`;
export const AccordionItemContainer = styled(Accordion.Item) `
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: ${themeGet('colors.background.50')};
  gap: ${themeGet('spacing.md')};
`;
export const AccordionTrigger = styled(Accordion.Trigger) `
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${themeGet('spacing.md')};
  min-height: ${pxToRem(24)};
  transition: all 175ms ease-in-out;

  &:focus-visible {
    outline: none;
    border: none;
    box-shadow: inset 0 0 0 ${pxToRem(2)} ${themeGet('colors.focus.primary')};
  }
`;
export const AccordionContent = styled(Accordion.Panel) `
  overflow: hidden;
  height: var(--accordion-panel-height);
  transition: height 300ms ease-out;

  &[data-starting-style],
  &[data-ending-style] {
    height: 0;
  }
`;
export const AccordionContentSpacer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${themeGet('spacing.sm')};
  padding-right: ${themeGet('spacing.md')};
  padding-bottom: ${themeGet('spacing.xl')};
  padding-left: calc(${ICON_WRAPPER_SIZE} + ${themeGet('spacing.md')});
`;
export const TextContainer = styled.div `
  display: flex;
  flex-direction: column;
  overflow: hidden;
  text-align: left;
`;
